module.exports = __webpack_public_path__ + "img/AD.085e104a.png";